import ModalBasicLayout from "../../Modal/ModalBasicLayout";

const GenerateCampaignModalLayout = ({
  children,
  modalOpen,
  onCloseModal,
}) => {
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      confirmClose
      fullWidth={true}
      maxWidth="md"
      scroll="paper"
      sxPaper={{
        maxWidth: 750,
      }}
    >
      {children}
    </ModalBasicLayout>
  );
};

export default GenerateCampaignModalLayout;
